
import { createModel } from './model'

const kebabCase = string => string
        .replace(/([a-z])([A-Z])/g, "$1-$2")
        .replace(/[\s_]+/g, '-')
        .toLowerCase()

function updateUrl(category) {
	const url = new URL(window.location)
	if (category) {
		url.searchParams.set('filter', category)
	} else {
		url.searchParams.delete('filter')
	}
	history.replaceState({}, '', url.toString())
}


function show(items, { category }) {
	if (!category.trim()) {
		items.map(item => item.style.display = '')
		return
	}

	items.map(item => {
		const categories = item.getAttribute('data-filter-categories').split(',').map(item => item.trim())
		const show = categories.indexOf(category) > -1
		item.style.display = show ? '' : 'none'
	})
}


export default () => {

	const el = document.querySelector('[data-filter]')
	if (!el) return
	const items = [...el.querySelectorAll('[data-filter-categories]')]
	const filters = [...el.querySelectorAll('[data-filter-by]')]
	if (!items.length || !filters) return
	
	// model

	const model = createModel()	

	// on change

	model.subscribe('category', category => {
		filters.forEach(el => el.classList.remove('active'))
		const current = filters.filter(el => el.getAttribute('data-filter-by') === category).shift()
		current && current.classList.add('active')
		show(items, model.data())
		updateUrl(category)
	})

	// event handlers

	filters.map(button => {
		button.addEventListener('click', e => {
			const category = e.currentTarget.getAttribute('data-filter-by')
			model.set('category', category)
		})
	})

	// init

	function setFromDOM() {
		const button = filters.filter(el => el.classList.contains('active')).shift()
		button && model.set('category', button.getAttribute('data-filter-by'))
	}

	setFromDOM()
}